"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var RainbowLoadingBar = function (props) {
    return (react_1.default.createElement("div", { className: "rainbow-loading-bar" },
        react_1.default.createElement("div", { className: "rainbow-loading-bar__bar", style: { width: "".concat(props.percent, "%") } },
            react_1.default.createElement("div", { className: "rainbow-loading-bar__progress" }))));
};
exports.default = RainbowLoadingBar;
